module.exports = __webpack_public_path__ + "static/media/chart_diversified.f2fad0f2.jpg";